import Field from "./Field";

class ActivityNoteField extends Field {
  get isMovableInLayout() {
    return true;
  }
}

export default ActivityNoteField;
